import { create } from 'zustand'

interface AmuseBoostStore {
    isAmuseBoostModalOpen: boolean
    setIsAmuseBoostModalOpen: (isOpen: boolean) => void
}

export const useAmuseBoostStore = create<AmuseBoostStore>((set) => ({
    isAmuseBoostModalOpen: false,
    setIsAmuseBoostModalOpen: (isOpen) => set({ isAmuseBoostModalOpen: isOpen }),
}))
